import React from 'react';
import Icon from '../../../components/AppIcon';

/**
 * DEMO / TRIAL ONLY — banner shown at the top of the form when opened via ?demo=recent|legacy.
 * Makes the scenario obvious for the Campaigning Tool demo and, for the "recent" scenario, lists
 * the fields the vendor should double-check. Never renders in real registration/regularization.
 */
const FIELD_LABELS = {
  registeredState: 'State',
  supplyState: 'Supply State',
  gstNumber: 'GST Number',
  ifscCode: 'Bank IFSC / Account',
  panNumber: 'PAN Number',
};

const DemoScenarioBanner = ({ scenario }) => {
  if (!scenario) return null;
  const recent = scenario.id === 'recent';
  const flags = scenario.flaggedFields || [];

  const tone = recent
    ? 'border-blue-300 bg-blue-50 text-blue-900'
    : 'border-amber-300 bg-amber-50 text-amber-900';

  return (
    <div className={`mb-6 rounded-lg border ${tone} p-4`} role="status" aria-live="polite">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-white/70">
          <Icon name={recent ? 'ClipboardCheck' : 'FilePlus2'} size={18} />
        </span>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <span className="rounded bg-white/70 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide">Demo</span>
            <p className="text-sm font-semibold">{scenario.label}</p>
          </div>
          {recent ? (
            <div className="mt-2 text-sm">
              <p>Your details are already on file. Please double-check the flagged fields below and confirm the rest.</p>
              {flags.length > 0 && (
                <div className="mt-2 flex flex-wrap items-center gap-1.5">
                  <span className="text-xs font-medium">Please double-check:</span>
                  {flags.map((f) => (
                    <span
                      key={f.key}
                      title={f.message}
                      className="inline-flex items-center gap-1 rounded-full border border-blue-300 bg-white px-2.5 py-0.5 text-xs font-medium text-blue-800"
                    >
                      <Icon name="Flag" size={11} />
                      {FIELD_LABELS[f.key] || f.key}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <p className="mt-1 text-sm">
              We only have a few of your older details on file. Please complete the new requirements below —
              GSTIN verification, MSME/Udyam, bank verification, and SPOC details.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DemoScenarioBanner;
